import { CommonService } from './../../../services/common/common.service';
// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatCalendar } from '@angular/material/datepicker';
import { NgbDateStruct, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { AbstractControl, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

// Service Class
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CppService } from './../../../services/cpp/cpp.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { BlanketAddProductSliderModelService } from '../../blanket-order/add-product/blanket-add-product-slider-model.service';
import { UploadAddProductSliderModelService } from '../upload-add-product/upload-add-product-slider-model.service';

// Class
import { MasterConstants } from '../../../common/constants/master-constants';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { UploadProductComponent } from './../upload-product/upload-product.component';
import { QuoteOrderService } from '../../../services/quote-order/quote-order.service';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-create-blanket-order',
  templateUrl: './create-blanket-order.component.html',
  styleUrls: ['./create-blanket-order.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class CreateBlanketOrderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('calendar') matcalendar: MatCalendar<Date>;

  private subscription = new Array<Subscription>();

  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 1;

  // Drop Down Lists Data
  shipToFacilityList: any[];
  soldToFacility: any[];
  deliverToList: any[];
  ddlInstructionTypeList: any[];
  // Header selected values
  shipToAccount: number;
  shipToAccountName: number;
  deliverToAccount: number;
  soldToAccount: number;
  instructionType: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  specialInstructionText: string;
  purchaseOrder: string;
  configurationMessage: any[];
  statusNoticeData: any = {};
  statusNotice = '';

  blanketProductItemsDataSource: any;
  blanketOriginalProductItemsDataSource: any;
  itemNoList: any = [];
  displayedColumns: string[];
  instructionTypeList: Object;
  allChecked = false;
  isSaveOrderDraftEnable = false;
  isPlaceOrderEnable = false;
  isAddProductEnable = false;
  filterArray = [];
  showTabs = false;
  tabNode: string;
  editToolKit = false;
  datemodel: NgbDateStruct;
  // done to remove prod errors
  NumericPattern: any = /^[A-Za-z0-9]+$/;
  isCustPONotValid = false;
  shipToDataLoading: any;
  soldToDataLoading: any;
  deliverToDataLoading: any;
  disablecheckbox: any;
  selectedCount = 0;
  isSearchClicked: any;
  index: any;
  enable: any;
  webOrderNumber: any;
  isEditMode = false;
  hasChangeAdded = false;
  dateFilter: any;
  sub: Subscription;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  // emailPattern: any = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
  readOnlyAccess = false;
  userMenuAccessList: any;
  date = new Date();
  matDialogRef: MatDialogRef<UploadProductComponent>;
  e5_error: string;
  e8_error: string;
  e9_error: string;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  plAccess = false;
  disclaimerMessage: string;
  isBulkRequestedColumnShow = false;
  blkContactName: string;
  blkContactNumber: String;
  isPhoneNotValid = false;
  bulkRequestedDateMsg: string;
  bulkContactNumberTooltip: string;
  bulkContactDetailsMsg: string;
  packageContactDetailsMsg: string;
  isShowBulkRequestedDateCalender: boolean = false;
  minDate: Date;
  maxDate: Date;
  isShowBulkContactDetails = false;
  existingDraftOrderMsg: string;
  isPlaceOder: boolean = false;
  isSubscriptionAccess: boolean = true;
  cppDeliveryInstructionList: any;
  cppBulkContactInfo: string;
  lastBulkContactSearched: string = '';
  inputBulkContactName$ = new Subject<string | null>();
  pkgContactName: string;
  pkgContactNumber: string;
  cppPackagedContactInfo: string;
  isShowPackagedContactDetails: boolean = false;
  deliveryInstructionsCodeList: any = [{ id: 'PJK', value: 'Pallet Jack Required' }, { id: 'DRA', value: 'Driver Required Assistance' }, { id: 'UNMAN', value: 'Unmanned Location' }];
  cppDeliveryInstructionCode: Array<string> = [];
  cppPackagedDeliveryInstructionList: any = [];
  lastPackagedContactSearched: string = '';
  inputPackagedContactName$ = new Subject<string | null>();
  alphaNumericPattern: any = /^[A-Za-z0-9]+$/;
  alphaNumericPatternWithSpace: any = /^[A-Za-z0-9 ]+$/;

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    private blanketOrderService: BlanketOrderService,
    private cppOrderService: CppService,
    private matDialog: MatDialog,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private commonService: CommonService,
    private blanketAddProductSliderModelService: BlanketAddProductSliderModelService,
    private uploadAddProductSliderModelService: UploadAddProductSliderModelService,
    private quoteService: QuoteOrderService,
    private localStorageService: LocalStorageService) {
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';

    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        // Set Subscription Access
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
        // this.accountEmail = data.resultData[0].emailId;

        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.EARLY_ADVANTAGE_ORDER);
        this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
      }
    }

    this.bulkRequestedDateMsg = this.configurationMessage.find(x => x.id === 'EAU_BULK_REQUEST_DATE_MESSAGE')?.value;
    this.bulkContactNumberTooltip = this.configurationMessage.find(x => x.id === 'EAU_BULK_CONTACT_NUMBER_MESSAGE')?.value;
    this.bulkContactDetailsMsg = this.configurationMessage.find(x => x.id === 'EAU_BULK_CONTACT_DETAILS_ERROR')?.value;
    this.existingDraftOrderMsg = this.configurationMessage.find(x => x.id === 'EAU_EXISITNG_DRAFT_ORDER')?.value;
    this.packageContactDetailsMsg = this.configurationMessage.find(x => x.id === 'EAU_PACKAGE_CONTACT_DETAILS_ERROR')?.value;
    this.hasChangeAdded = false;
    this.loadMasterData();
    this.blanketProductItemsDataSource = new MatTableDataSource([]);
    this.blanketOriginalProductItemsDataSource = this.blanketProductItemsDataSource.data;
    this.disablecheckbox = true;

    this.subscription.push(this.blanketAddProductSliderModelService.BlanketModelData.subscribe(x => {
      if (x != null && x.selectedProductList) {
        this.setGridDataAndMessage(x.selectedProductList);
      }
    }));

    this.subscription.push(this.uploadAddProductSliderModelService.uploadAddModelData.subscribe(x => {
      if (x != null && x.selectedProductList) {
        this.setGridDataAndMessage(x.selectedProductList);
      }
    }));

    this.inputBulkContactName$.subscribe((newTerm) => {
      if (newTerm) {
        this.lastBulkContactSearched = newTerm;
      }
    });

    this.inputPackagedContactName$.subscribe((newTerm) => {
      if (newTerm) {
        this.lastPackagedContactSearched = newTerm;
      }
    });

    this.errorMsgs = new Array();
    this.statusNoticeData.eauOderCreationNoticeStatus = this.configurationMessage.filter(x => x.id === 'EAU_STATUS_NOTICE');
    this.statusNotice = this.statusNoticeData.eauOderCreationNoticeStatus[0].value;
    this.setdisplayedColumns();
  }

  setGridDataAndMessage(selectedProductList) {
    if (!this.e5_error) {
      const errorMessages = selectedProductList[0]?.errorMessages;
      if (errorMessages) {
        this.e5_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA05')[0]?.message;
        this.e8_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA08')[0]?.message;
        this.e9_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA09')[0]?.message;
      }
    }

    this.formatNewAddedData(selectedProductList);
    this.enablePlaceOrderAndSaveOrderDraft();
    this.setdisplayedColumns();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.createCPPOuter').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  formatNewAddedData(productList: any[], isNewProduct = true) {
    const orderList = [];
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    let rowId = 0;
    this.blanketProductItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    productList.forEach(x => {
      rowId = rowId + 1;
      const duplicateData = orderList.find(y => y.itemId == x.itemId);
      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          gtin: x.gtin,
          activeIngredient: x.activeIngredient,
          productSegment: x.productSegment,
          productLine: x.productLine,
          palletQuantity: x.palletQuantity,
          programName: x.programName,
          bulkPackaged: x.bulkPackaged,
          vendedProprietary: x.vendedProprietary,
          xrefCheckBK: x.xrefCheckBK,
          itemFlashMsg: x.itemFlashMsg,
          restrictedUse: x.restrictedUse,
          returnable: x.returnable,
          uom: x.uom,
          price: x.price,
          pricePerUnit: x.pricePerUnit,
          priceCurrency: x.priceCurrency,
          pricingUnitOfMeasure: x.pricingUnitOfMeasure,
          pricingPackageSize: x.pricingPackageSize,
          isFavorite: x.isFavorite,
          deliveryDate: x.isValidBulkItem && isNewProduct ? null : x.desiredDelDate,
          defaultDeliveryDate: x.defaultDelDate,
          quantity: x.quantity,
          lineErrors: { 'rowId': rowId, 'errors': [] },
          orderConvFactor: x.uom == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderedQuantity: x.uom == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderingUOM: x.uom == 'IB' ? x.orderUOM : x.uom,
          modifiedUOMConverted: x.uom == 'IB' ? x.webStandardOrderUOM : x.webStandardUOM,
          pricingQuantity: x.pricingUnitConvFactor,
          pricingUnitConvFactor: x.pricingUnitConvFactor,
          convertedThresholdUnits: x.convertedThresholdUnits,
          hasNoConvF: x.hasNoConvF,
          hasNoPalletConvF: x.hasNoPalletConvF,
          thresholdUOM: x.thresholdUOM,
          palletConvF: x.palletConvF,
          yourPrice: x.yourPrice,
          paymentTerms: x.paymentTerms,
          isValidBulkItem: x.isValidBulkItem,
          bulkRequestedDateFrom: x.bulkRequestedDateFrom,
          bulkRequestedDateTo: x.bulkRequestedDateTo,
          itemFlashMsgDesc: x.itemFlashMsgDesc,
          isBIO: x.isBIO ? true : false
        };

        this.qtyCount = this.qtyCount + x.orderQty;
        this.totalPrice = this.totalPrice + (x.orderQty * x.price);
        orderList.splice(orderList.length, 0, newRow);
      }
    });

    this.filteredDataCount = orderList.length;
    this.blanketProductItemsDataSource.data = orderList;
    this.blanketOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.isBulkRequestedColumnShow = this.blanketOriginalProductItemsDataSource.some(x => x.isValidBulkItem);
    this.isShowBulkRequestedDateCalender = this.isBulkRequestedColumnShow;
    this.isShowBulkContactDetails = this.blanketOriginalProductItemsDataSource.some(x => x.bulkPackaged.toLowerCase() == "BULK".toLowerCase());
    this.isShowPackagedContactDetails = this.blanketOriginalProductItemsDataSource.some(x => x.bulkPackaged.toLowerCase() == "PACKAGED".toLowerCase());
    if (this.isBulkRequestedColumnShow) {
      const todayDate = new Date();
      const configMinDate = orderList.find(x => x.bulkRequestedDateFrom) ? new Date(orderList.find(x => x.bulkRequestedDateFrom).bulkRequestedDateFrom) : null;
      this.minDate = configMinDate && configMinDate < todayDate ? todayDate : configMinDate;
      this.maxDate = orderList.find(x => x.bulkRequestedDateTo) ? new Date(orderList.find(x => x.bulkRequestedDateTo).bulkRequestedDateTo) : null;
      if (this.minDate && this.maxDate) { this.validateDeliveryDateFilter(); }
    }

    if (this.blanketProductItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }
  }

  // Enable/Disable Save Draft Button and Place Order Button
  enablePlaceOrderAndSaveOrderDraft() {
    if (this.readOnlyAccess) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      if (this.blanketOriginalProductItemsDataSource && this.blanketOriginalProductItemsDataSource.length > 0 && this.shipToAccount
        && (!this.isNotValid)) {
        this.isSaveOrderDraftEnable = true;
        this.isPlaceOrderEnable = true;
      }
      else {
        this.isSaveOrderDraftEnable = false;
        this.isPlaceOrderEnable = false;
      }
    }
  }

  setdisplayedColumns() {
    if (this.isBulkRequestedColumnShow) { this.displayedColumns = ['checkbox', 'product', 'flashmsg', 'viewDetail', 'quantity', 'orderUOM', 'packageSize', 'requestedDate']; }
    else { this.displayedColumns = ['checkbox', 'product', 'flashmsg', 'viewDetail', 'quantity', 'orderUOM', 'packageSize']; }
  }

  // Show/Hide Product Detail section
  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    // get cpp Item Number List
    this.subscription.push(this.cppOrderService.getCppItemNumberList().subscribe((result: any[]) => {
      this.itemNoList = result;
    }));

    // get Cpp Ship To Facility List
    const getShipToFacility = this.blanketOrderService.blanketShipToList();
    const getInstructionType = this.cppOrderService.getCPPInstructionTypeList();
    this.subscription.push(forkJoin(getShipToFacility, getInstructionType).subscribe((result: any[]) => {
      this.shipToFacilityList = result[0];
      this.ddlInstructionTypeList = result[1];
      if (this.blanketOrderService.webOrderNumber) {
        const data = this.blanketOrderService.webOrderNumber.split('~');
        this.webOrderNumber = data[0];
        this.getOrderDetail();
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // get Order Details
  getOrderDetail() {
    /* this.loaderService.setLoaderStatus(true);*/
    this.subscription.push(this.blanketOrderService.getBlanketEditOrder(this.webOrderNumber).subscribe((result: any) => {
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = this.shipToFacilityList.find(x => x.accountNumber == result.shipToAccountId)?.accountName;
      this.bindSoldTo(result.shipToAccountId);
      this.webOrderNumber = result.webOrderNumber;
      this.specialInstructionText = result.headerText;
      this.purchaseOrder = result.purchaseOrderNumber;
      this.accountEmail = result.emailAddress;
      this.blkContactName = result.bulkContactName;
      this.blkContactNumber = result.bulkContactPhoneNumber;
      this.pkgContactName = result.packagedContactName;
      this.pkgContactNumber = result.packagedContactNumber;
      if (result.packagedDeliveryInst) {
        this.cppDeliveryInstructionCode = result.packagedDeliveryInst.split(',');
      }
      else {
        this.cppDeliveryInstructionCode = new Array<string>();
      }
      this.isAddProductEnable = true;
      this.isPlaceOrderEnable = true;
      this.isEditMode = true;
      this.formatNewAddedData(result.blanketOrderProductList, false);
      this.subscription.push(this.cppOrderService.getCPPDeliveryInstruction(this.shipToAccount).subscribe((resultDI: any[]) => {
        if (resultDI && resultDI.length > 0) {
          var bulkCppDeliveryInstruction = resultDI.filter(x => x.packagedType == 'BULK');
          if (bulkCppDeliveryInstruction && bulkCppDeliveryInstruction.length > 0) {
            bulkCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });
            this.cppDeliveryInstructionList = bulkCppDeliveryInstruction;
          }

          var packagedCppDeliveryInstruction = resultDI.filter(x => x.packagedType == 'PACKAGED');
          if (packagedCppDeliveryInstruction && packagedCppDeliveryInstruction.length > 0) {
            packagedCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });
            this.cppPackagedDeliveryInstructionList = packagedCppDeliveryInstruction;
          }

          if (this.blkContactName && this.blkContactNumber) {
            var selectedContact = this.blkContactName.replace(/ /g, '') + this.blkContactNumber;
            var primaryContact = bulkCppDeliveryInstruction.filter(x => x.contactNamePhoneNumber == selectedContact)[0];
            if (primaryContact) {
              this.cppBulkContactInfo = primaryContact.contactNamePhoneNumber;
            }
            else {
              primaryContact = { contactName: this.blkContactName, contactNamePhoneNumber: selectedContact, phoneNumber: this.blkContactNumber };
              this.cppDeliveryInstructionList.push(primaryContact);
              this.cppBulkContactInfo = selectedContact;
            }
          }

          if (this.pkgContactName && this.pkgContactNumber) {
            var selectedContact = this.pkgContactName.replace(/ /g, '') + this.pkgContactNumber;
            var primaryContact = packagedCppDeliveryInstruction.filter(x => x.contactNamePhoneNumber == selectedContact)[0];
            if (primaryContact) {
              this.cppPackagedContactInfo = primaryContact.contactNamePhoneNumber;
            }
            else {
              primaryContact = { contactName: this.pkgContactName, contactNamePhoneNumber: selectedContact, phoneNumber: this.pkgContactNumber };
              this.cppPackagedDeliveryInstructionList.push(primaryContact);
              this.cppPackagedContactInfo = selectedContact;
            }
          }
        }

        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
      this.setdisplayedColumns();
      const itemLength = [] = result.blanketOrderProductList;
      if (itemLength.length > 0) { this.setGridDataAndMessage(result.blanketOrderProductList); }
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // for adding product
  addProduct() {
    this.blanketAddProductSliderModelService.shipToAccount = this.shipToAccount;
    this.blanketAddProductSliderModelService.activeSlider('AddBlanketProductSlider');
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.blanketProductItemsDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.selectedCount = this.blanketProductItemsDataSource.data.length;
    }
    else {
      this.showTabs = false;
      this.blanketProductItemsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedCount = 0;
    }
    const checked = this.blanketProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
    this.isShowBulkRequestedDateCalender = checked.some(x => x.isValidBulkItem);
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.selectedCount = this.selectedCount + 1;
      const checked = this.blanketProductItemsDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      this.allChecked = false;
      const checked = this.blanketProductItemsDataSource.data.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
      }
    }
    const checked = this.blanketProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
    this.isShowBulkRequestedDateCalender = checked.some(x => x.isValidBulkItem);
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // get total product count
  getTotalProductCount() {
    return this.blanketProductItemsDataSource.data.length;
  }

  getShipTo(event) {
    if (event) {
      // Check for existing Draft Order
      this.subscription.push(this.blanketOrderService.getExisitngDraftOrder(event.accountNumber).subscribe((webOrderNumber: string) => {
        if (webOrderNumber != null) {
          // Added Popup
          const title = 'Confirmation';
          const message = this.existingDraftOrderMsg;
          const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
            disableClose: true,
            width: '390px',
            data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
          });

          this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
            if (yes == true) {// User selected Yes
              this.loaderService.setLoaderStatus(true);
              this.blanketOrderService.webOrderNumber = webOrderNumber;
              this.webOrderNumber = webOrderNumber;
              this.getOrderDetail();
              return;
            } else {
              this.setNullableFields(event);
            }
          }));
        } else {
          this.setNullableFields(event);
        }
      }));
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppOrderService.getCPPDeliveryInstruction(event.accountNumber).subscribe((result: any[]) => {
        if (result && result.length > 0) {
          var bulkCppDeliveryInstruction = result.filter(x => x.packagedType == 'BULK');
          if (bulkCppDeliveryInstruction && bulkCppDeliveryInstruction.length > 0) {
            bulkCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });
            this.cppDeliveryInstructionList = bulkCppDeliveryInstruction;

            var primaryContact = bulkCppDeliveryInstruction.filter(x => x.contactType.toLowerCase() == 'primary')[0];
            if (primaryContact) {
              this.cppBulkContactInfo = primaryContact.contactNamePhoneNumber;
              this.blkContactName = primaryContact.contactName;
              this.blkContactNumber = primaryContact.phoneNumber;
            }
            else {
              this.cppBulkContactInfo = bulkCppDeliveryInstruction[0].contactNamePhoneNumber;
              this.blkContactName = bulkCppDeliveryInstruction[0].contactName;
              this.blkContactNumber = bulkCppDeliveryInstruction[0].phoneNumber;
            }
          }
          else {
            this.cppBulkContactInfo = null;
            this.blkContactName = null;
            this.blkContactNumber = null;
            this.cppDeliveryInstructionList = null;
          }

          var packagedCppDeliveryInstruction = result.filter(x => x.packagedType == 'PACKAGED');
          if (packagedCppDeliveryInstruction && packagedCppDeliveryInstruction.length > 0) {
            packagedCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });
            this.cppPackagedDeliveryInstructionList = packagedCppDeliveryInstruction;

            var primaryContact = packagedCppDeliveryInstruction.filter(x => x.contactType.toLowerCase() == 'primary')[0];
            if (primaryContact) {
              this.cppPackagedContactInfo = primaryContact.contactNamePhoneNumber;
              this.pkgContactName = primaryContact.contactName;
              this.pkgContactNumber = primaryContact.phoneNumber;
              if (primaryContact.deliveryInstructions) {
                this.cppDeliveryInstructionCode = primaryContact.deliveryInstructions.split(',');
              }
              else {
                this.cppDeliveryInstructionCode = new Array<string>();
              }
            }
            else {
              this.cppPackagedContactInfo = packagedCppDeliveryInstruction[0].contactNamePhoneNumber;
              this.pkgContactName = packagedCppDeliveryInstruction[0].contactName;
              this.pkgContactNumber = packagedCppDeliveryInstruction[0].phoneNumber;
            }
          }
          else {
            this.cppPackagedContactInfo = null;
            this.pkgContactName = null;
            this.pkgContactNumber = null;
            this.cppPackagedDeliveryInstructionList = null;
          }
        }
        else {
          this.cppBulkContactInfo = null;
          this.blkContactName = null;
          this.blkContactNumber = null;
          this.cppDeliveryInstructionList = null;
          this.cppPackagedContactInfo = null;
          this.pkgContactName = null;
          this.pkgContactNumber = null;
          this.cppPackagedDeliveryInstructionList = null;
        }

        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
    }
    else {
      this.deliverToList = null;
      this.deliverToAccount = null;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.disablecheckbox = true;
      this.isShowBulkContactDetails = false;
      this.isShowPackagedContactDetails = false;
      this.blkContactName = null;
      this.blkContactNumber = null;
      this.pkgContactName = null;
      this.pkgContactNumber = null;
      this.cppDeliveryInstructionCode = new Array<string>();
    }
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
    this.isBulkRequestedColumnShow = false;
    this.isShowBulkRequestedDateCalender = false;
    this.blanketProductItemsDataSource.data = [];
    this.blanketOriginalProductItemsDataSource = [];
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  bindSoldTo(accountNumber) {
    this.subscription.push(this.cppOrderService.getSoldToFacility(accountNumber).subscribe((result: any[]) => {
      this.soldToFacility = [result];
      this.soldToAccount = this.soldToFacility[0].accountNumber;
      /* this.loaderService.setLoaderStatus(false);*/
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getBulkContactPhone(event) {
    if (event && event.contactName && event.phoneNumber) {
      this.blkContactNumber = event.phoneNumber;
      this.blkContactName = event.contactName;
      this.lastBulkContactSearched = null;
    }
    else if (event) {
      this.blkContactName = event.contactName;
      this.blkContactNumber = null;
    }
    else {
      this.blkContactNumber = null;
      this.blkContactName = null;
      this.lastBulkContactSearched = null;
    }
  }

  getPackagedContactPhone(event) {
    if (event && event.contactName && event.phoneNumber) {
      this.pkgContactNumber = event.phoneNumber;
      this.pkgContactName = event.contactName;
      this.lastPackagedContactSearched = null;
    }
    else if (event) {
      this.pkgContactName = event.contactName;
      this.pkgContactNumber = null;
    }
    else {
      this.pkgContactNumber = null;
      this.pkgContactName = null;
      this.lastPackagedContactSearched = null;
    }
  }

  //Search the bulk contact name
  bulkContactNameSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.firstName.toLocaleLowerCase().indexOf(term) > -1
      || item.lastName.toLocaleLowerCase().indexOf(term) > -1;
  }

  //Search the bulk contact name
  packagedContactNameSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.firstName.toLocaleLowerCase().indexOf(term) > -1
      || item.lastName.toLocaleLowerCase().indexOf(term) > -1;
  }

  createNewContact() {
    if (this.lastBulkContactSearched) {
      var isContactNameExists = null;
      if (this.cppDeliveryInstructionList && this.cppDeliveryInstructionList.length > 0) {
        isContactNameExists = this.cppDeliveryInstructionList.filter(x => x.contactNamePhoneNumber == this.lastBulkContactSearched)[0];
      }

      if (!isContactNameExists) {
        var primaryContact = { contactName: this.lastBulkContactSearched, contactNamePhoneNumber: this.lastBulkContactSearched, phoneNumber: '' };
        if (this.cppDeliveryInstructionList && this.cppDeliveryInstructionList.length > 0) {
          this.cppDeliveryInstructionList = [...this.cppDeliveryInstructionList, primaryContact];
        }
        else {
          this.cppDeliveryInstructionList = [primaryContact];
        }
        this.cppBulkContactInfo = this.lastBulkContactSearched;
        this.blkContactName = this.lastBulkContactSearched;
        this.blkContactNumber = null;
      }
    }
  }

  createNewPackagedContact() {
    if (this.lastPackagedContactSearched) {
      var isContactNameExists = null;
      if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
        isContactNameExists = this.cppPackagedDeliveryInstructionList.filter(x => x.contactNamePhoneNumber == this.lastPackagedContactSearched)[0];
      }

      if (!isContactNameExists) {
        var primaryContact = { contactName: this.lastPackagedContactSearched, contactNamePhoneNumber: this.lastPackagedContactSearched, phoneNumber: '' };
        if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
          this.cppPackagedDeliveryInstructionList = [...this.cppPackagedDeliveryInstructionList, primaryContact];
        }
        else {
          this.cppPackagedDeliveryInstructionList = [primaryContact];
        }
        this.cppPackagedContactInfo = this.lastPackagedContactSearched;
        this.pkgContactName = this.lastPackagedContactSearched;
        this.pkgContactNumber = null;
      }
    }
  }

  setNullableFields(event) {
    this.bindSoldTo(event.accountNumber);
    this.shipToAccountName = event.accountName;
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.isShowBulkContactDetails = false;
    this.isShowPackagedContactDetails = false;
    this.isShowBulkRequestedDateCalender = false;
    this.isBulkRequestedColumnShow = false;
    this.webOrderNumber = undefined;
  }

  hasHeaderInfoChanged(fieldName) {
    if (fieldName && this.shipToAccount && this.isEditMode) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      switch (fieldName) {
        case 'PO':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
          break;
        case 'Special Instructions':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppSplInsValue: true });
          break;
        case 'Email Address':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppEmailAddressValue: true });
          break;
        case 'Bulk Name':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppBulkNameValue: true });
          break;
        case 'Bulk Number':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppBulkNumberValue: true });
          break;
      }
      this.enablePlaceOrderAndSaveOrderDraft();
    }
  }

  validateDeliveryDateFilter() {
    this.config.minDate = { year: this.minDate.getFullYear(), month: this.minDate.getMonth() + 1, day: this.minDate.getDate() };
    this.config.maxDate = { year: this.maxDate.getFullYear(), month: this.maxDate.getMonth() + 1, day: this.maxDate.getDate() };
    this.datemodel = this.configDate.getToday();
    this.tabNode = '';
  }

  SetAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        if (value == true) {
          const refreshData = [];
          this.blanketProductItemsDataSource.data.forEach(item => {
            if (item.isSelected) {
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
              refreshData.push(item.itemId);
              this.selectedCount = this.selectedCount - 1;
              item.isSelected = false;
            }
          });

          var filterDataAfterDeletion = this.blanketProductItemsDataSource.data.filter(x => refreshData.indexOf(x.itemId) == -1);
          this.isBulkRequestedColumnShow = filterDataAfterDeletion.some(x => x.isValidBulkItem);
          this.isShowBulkContactDetails = filterDataAfterDeletion.some(x => x.bulkPackaged.toLowerCase() == "BULK".toLowerCase());
          this.isShowPackagedContactDetails = filterDataAfterDeletion.some(x => x.bulkPackaged.toLowerCase() == "PACKAGED".toLowerCase());
          this.setdisplayedColumns();
          if (filterDataAfterDeletion.length < 1) {
            this.disablecheckbox = true;
          }
          this.blanketProductItemsDataSource = new MatTableDataSource(filterDataAfterDeletion);
          this.blanketOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.blanketProductItemsDataSource.data));
          this.enablePlaceOrderAndSaveOrderDraft();
        }
        this.setCount();
        this.tabNode = '';
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        break;
      case 'deliverydate':
        this.blanketProductItemsDataSource.data.forEach(item => {
          if (item.isSelected && item.isValidBulkItem) {
            item.deliveryDate = new Date(value.year, value.month - 1, value.day);
            this.selectedCount = this.selectedCount - 1;
            item.isSelected = false;
            this.validateDate(item);
          }
        });
        this.enablePlaceOrderAndSaveOrderDraft();

        this.setCount();
        this.tabNode = '';
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        break;
      default:
        break;
    }
  }

  validateOrder() {
    let isValidated = true;
    if (this.blanketProductItemsDataSource.data && this.blanketProductItemsDataSource.data.length > 0) {
      isValidated = true;
      this.blanketProductItemsDataSource.data.forEach(x => {
        x = this.validateLineItem(x);
        if (x.lineErrors.errors.length > 0) {
          this.errorMsgs.push(x.lineErrors);
          this.getCommonErrors(this.errorMsgs);
          isValidated = false;
        }
      });
    }
    if (this.isBulkRequestedColumnShow) {
      if ((this.isBulkRequestedColumnShow) && (!this.blkContactName || !this.blkContactNumber)) {
        this.toastrService.error(this.bulkContactDetailsMsg);
        isValidated = false;
      }
    }

    if (this.isShowPackagedContactDetails) {
      if ((this.isShowPackagedContactDetails) && (!this.pkgContactName || !this.pkgContactNumber)) {
        this.toastrService.error(this.packageContactDetailsMsg);
        isValidated = false;
      }
    }
    return isValidated;
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should be greater than zero' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
    }

    if (item.quantity < item.convertedThresholdUnits) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'thresholdUnits');
      item.lineErrors.errors.push({ id: 'thresholdUnits', error: this.e5_error.replace('{0}', item.convertedThresholdUnits).replace('{1}', item.uom) });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'thresholdUnits');
    }

    if (item.quantity > 0 && item.palletConvF > 0 && item.quantity % item.palletConvF != 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      item.lineErrors.errors.push({ id: 'conv', error: this.e8_error.replace('{0}', item.palletConvF).replace('{1}', item.uom) });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
    }

    if (item.deliveryDate == null || item.deliveryDate == undefined) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'requestedDate');
      item.lineErrors.errors.push({ id: 'requestedDate', error: this.bulkRequestedDateMsg });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'requestedDate');
    }

    return item;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#cppOrderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#cppOrderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#cppOrderView').scrollTop = 0;
      $('#cppOrderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.blanketOriginalProductItemsDataSource.length > 0 && this.blanketProductItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        this.revertSingleIndex(element);
      }
      else {
        // revert lines having error only
        this.blanketProductItemsDataSource.data.forEach(x => {
          if (x.lineErrors && x.lineErrors.errors && x.lineErrors.errors.length > 0) {
            this.revertSingleIndex(x);
          }
        });

        // replace whole object
        // this.blanketProductItemsDataSource.data = JSON.parse(JSON.stringify(this.blanketOriginalProductItemsDataSource));
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  revertSingleIndex(element: any) {
    if (element && element != null) {
      // get old data
      const oldLineValue = this.blanketOriginalProductItemsDataSource.filter(x => x.rowId == element.rowId)[0];

      // get current object index
      const currentLineIndex = this.blanketProductItemsDataSource.data.findIndex(x => x.rowId == element.rowId);

      // replace current with old object if exist
      if (currentLineIndex != -1) {
        this.blanketProductItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
        this.blanketProductItemsDataSource.data = this.blanketProductItemsDataSource.data;

        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

        // to hide one error after revert changes
        this.showHideLineError(oldLineValue.rowId);
        this.getCommonErrors(this.errorMsgs);
      }
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Dealer unit change and validation
  orderUnitChange(action: string, productItem: any) {
    const palletConvF = productItem.palletConvF ? +productItem.palletConvF : 1;
    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.quantity;
        productItem.quantity = Math.floor(productItem.quantity / palletConvF) * palletConvF;
        if (valueBeforeDec == productItem.quantity) {
          productItem.quantity = (+productItem.quantity > palletConvF ? +productItem.quantity - palletConvF : 0);
        }
      }
      else {
        productItem.quantity = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.quantity;
      productItem.quantity = Math.ceil(productItem.quantity / palletConvF) * palletConvF;
      if (valueBeforeInc == productItem.quantity) {
        productItem.quantity = (+productItem.quantity + palletConvF);
      }
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.blanketOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPQtyValue: oldProductLineValue.quantity, newCPPQtyValue: productItem.quantity });

    this.validateLineItem(productItem);
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.blanketOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPQtyValue: oldProductLineValue.quantity, newCPPQtyValue: productItem.quantity });

    this.validateLineItem(productItem);
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.blanketProductItemsDataSource.data.length;
    this.blanketProductItemsDataSource.data.forEach(x => {
      this.qtyCount = this.qtyCount + +(x.quantity);
      this.totalPrice = this.totalPrice + (x.quantity * x.price);
    });
  }

  navigateToLandingPage() {
    this.subscription.push(this.quoteService.checkQuoteOrderTabAccess().subscribe(result => {
      const hasQuoteTabAccess = result;
      if (hasQuoteTabAccess) {
        this.router.navigate(['/cpp/landing-data']);
        this.commonService.currentTabIndex.next(4);
      }
      else {
        this.router.navigate(['/cpp/landing-data']);
        this.commonService.currentTabIndex.next(3);
      }
    }));
  }

  // On page destroy
  ngOnDestroy() {
    if (!this.isPlaceOder) { this.blanketOrderService.webOrderNumber = undefined; }

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    if (this.isNotValid) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      this.enablePlaceOrderAndSaveOrderDraft();
    }
    this.matcher = new InputErrorStateMatcher(this.isNotValid);
  }

  phoneShouldBeValid(phone: AbstractControl) {
    this.isPhoneNotValid = false;
    if (phone.valid) {
      this.isPhoneNotValid = false;
    } else {
      this.isPhoneNotValid = true;
    }
    this.matcher = new InputErrorStateMatcher(this.isPhoneNotValid);
  }

  validateCustPO() {
    this.isCustPONotValid = false;
    if (this.purchaseOrder && !this.NumericPattern.test(this.purchaseOrder)) {
      this.isCustPONotValid = true;
    };
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  keyPressNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (this.NumericPattern.test(inp)) {
      this.validateCustPO();
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  placeOrder() {
    let saveObj: any = {};
    saveObj = this.createSaveObj();

    if (this.validateOrder()) {
      this.loaderService.setLoaderStatus(true);

      this.subscription.push(this.blanketOrderService.placeOrder(saveObj).subscribe((result: any) => {
        if (result) {
          let isValidated = true;
          if (result.errors.length > 0) {
            result.errors.forEach(x => {
              this.toastrService.error(x);
              isValidated = false;
              return false;
            });
          }

          if (result.blanketOrderProductList.length > 0) {
            const blanketOrderProductList = result.blanketOrderProductList;
            this.blanketProductItemsDataSource.data.forEach(x => {
              const item = blanketOrderProductList.filter(z => z.itemId == x.itemId);

              if (item[0].isInValidItem) {
                isValidated = false;
                x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'validItem');
                x.lineErrors.errors.push({ id: 'validItem', error: 'This product is not available for ordering' });
              }
              else {
                x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'validItem');
                x.lineErrors.errors = item[0].lineErrors.errors;
                this.errorMsgs = this.errorMsgs.filter(y => y.rowId != item.rowId);
              }

              if (x.lineErrors.errors.length > 0) {
                isValidated = false;
                this.errorMsgs.push(x.lineErrors);
                this.getCommonErrors(this.errorMsgs);
              }
            });
          }

          if (isValidated) {
            this.toastrService.success('Order #' + result.webOrderNumber + ' placed successfully.');
            if (result.bulkItemWarningMsg) {
              this.toastrService.warning(result.bulkItemWarningMsg);
            }
            this.isPlaceOder = true;
            this.blanketOrderService.webOrderNumber = result.webOrderNumber + '~EABlanket' + '~CPPLanding';
            this.router.navigate(['/cpp/blanket-order-summary']);

            this.commonService.currentTabIndex.next(3);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, (error) => {
        this.isPlaceOrderEnable = true;
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
        LolLoggerService.error(error);
      }));
    }
  }

  saveDraft() {
    this.loaderService.setLoaderStatus(true);
    let saveObj: any = {};
    saveObj = this.createSaveObj();

    this.subscription.push(this.blanketOrderService.saveOrder(saveObj).subscribe((result: any) => {
      if (result) {
        this.webOrderNumber = result.webOrderNumber;
        this.toastrService.success('Order #' + result.webOrderNumber + ' saved successfully.');
        if (result.bulkItemWarningMsg) {
          this.toastrService.warning(result.bulkItemWarningMsg);
        }
        this.blanketOrderService.webOrderNumber = result.webOrderNumber + '~EABlanket' + '~CPPLanding';
        this.navigateToLandingPage();
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        this.loaderService.setLoaderStatus(false);
      }
    }, (error) => {
      this.isPlaceOrderEnable = true;
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Order not saved in the system.');
      LolLoggerService.error(error);
    }));
  }

  createSaveObj(): any {
    $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
    this.isPlaceOrderEnable = false;
    const saveObj: any = {};
    saveObj.companyCode = this.headerCompany;
    saveObj.shipToAccountId = this.shipToAccount;
    saveObj.soldToId = this.soldToAccount;
    saveObj.purchaseOrderNumber = this.purchaseOrder;
    saveObj.bulkContactName = this.isShowBulkContactDetails ? this.blkContactName : null;
    saveObj.bulkContactPhoneNumber = this.isShowBulkContactDetails ? this.blkContactNumber : null;
    saveObj.packagedContactName = this.isShowPackagedContactDetails ? this.pkgContactName : null;
    saveObj.packagedContactNumber = this.isShowPackagedContactDetails ? this.pkgContactNumber : null;
    saveObj.packagedDeliveryInst = this.cppDeliveryInstructionCode && this.cppDeliveryInstructionCode.length > 0 ? this.cppDeliveryInstructionCode.join(',') : null;
    saveObj.isUpdateRequest = this.webOrderNumber ? true : false;
    saveObj.webOrderNumber = this.webOrderNumber;
    if ((this.specialInstructionText && (this.specialInstructionText.trim() != ''))) {
      saveObj.headerText = this.specialInstructionText.trim();
      saveObj.instructionType = 41;// this.instructionType; HeaderAttachment
    }

    saveObj.emailAddress = this.accountEmail;
    saveObj.blanketOrderProductList = this.blanketProductItemsDataSource.data;

    saveObj.blanketOrderProductList.forEach(x => {
      x.deliverydate = (new Date(x.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
      x.modifiedOrderedQuantity = x.orderConvFactor * x.quantity,
        x.pricingQuantity = x.pricingUnitConvFactor * x.quantity;
    });

    return saveObj;
  }

  keyPressAlphaNumeric(event, isValidateCustPO) {
    var inp = String.fromCharCode(event.keyCode);
    if (this.alphaNumericPattern.test(inp)) {
      if (isValidateCustPO == 1)
        this.validateCustPO();
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumericWithSpace(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (this.alphaNumericPatternWithSpace.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  convertFirstWordToUpperCase(str) {
    var arr = str.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    var finalstring = arr.join(" ");
    this.blkContactName = finalstring;
  }

  uploadProduct() {
    this.uploadAddProductSliderModelService.shipToAccount = this.shipToAccount;
    this.matDialogRef = this.matDialog.open(UploadProductComponent, {
      disableClose: true
    });

    this.subscription.push(this.matDialogRef.afterClosed().subscribe(res => {
    }));
  }

  // Date validation
  validateDate(productItem: any) {
    const oldProductLineValue = JSON.parse(JSON.stringify(this.blanketProductItemsDataSource.data)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPEADateValue: oldProductLineValue.deliveryDate, newCPPDateValue: productItem.deliveryDate });

    if ((productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0)) {
      this.validateLineItem(productItem);
    }

    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }
}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
